import RadioBox from "Components/FormControl/RadioBox/RadioBox";
import { MODULES } from "Helpers/Constants";
import { setAllStore } from "Helpers/setAllStore";
import moment from "moment";
import React, { useContext, useState, useEffect } from "react";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";
import { getAccessByModuleName } from "Routes/Routes";
import { getProductOrder } from "../../../api/report";
import ViewIcon from "../../../Assets/images/error-outline.svg";
import Select from "../../../Components/FormControl/Select/Select";
import ReactTable from "../../../Components/Table/Table";
import { AppContext } from "../../../Context/AppContext";
import ExportIcon from "./../../../Assets/images/Export.svg";
// Components
import Header from "./../../../Components/Header/Header";
import styles from "./index.module.scss";
import GlobalDateFilters from "Components/GlobalDateFilters/GlobalDateFilters";
const ProductsOrder = () => {
  const navigate = useNavigate();
  const { showToastMessage, modules } = useContext(AppContext);
  let accessExport = getAccessByModuleName(
    modules,
    MODULES.PRODUCT_ORDER_REPORT
  );
  const statusList = [
    { id: "ALL", title: "All" },
    { id: "NON_ADD_ONS", title: "Product" },
    { id: "ADD_ONS", title: "Add On" },
  ];
  const [type, setType] = useState("delivery_date");
  const filterOption = [
    { id: "weekly", title: "Weekly", label: "By Week" },
    { id: "monthly", title: "Monthly", label: "By Month" },
    { id: "yearly", title: "Yearly", label: "By Year" },
    { id: "custom", title: "Custom", label: "Custom" },
  ];

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const [productType, setProductType] = React.useState("");
  const reference = React.useRef(null);

  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: "",
  });

  const [fromDate, setFromDate] = useState(
    moment().startOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [toDate, setToDate] = useState(
    moment().endOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [selectedPeriod, setSelectedPeriod] = React.useState("weekly");
  const [selectedPeriodLabel, setSelectedPeriodLabel] = React.useState(
    "By Week"
  );

  const [firstTimePageLoad, setFirstTimePageLoad] = React.useState(false);
  const [exportData, setExportData] = React.useState([]);
  const [exportHeader, setExportHeader] = React.useState([]);
  
  const [checkAllStore,setCheckAllStore] = useState(true);
  const [shouldTriggerDownload, setShouldTriggerDownload] = useState(false);

  // Effect to trigger CSV download after state update
  useEffect(() => {
    if (shouldTriggerDownload && exportData.length > 0) {
      reference.current?.link?.click();
      setShouldTriggerDownload(false);
    }
  }, [shouldTriggerDownload, exportData]);

  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    fromDateDefault,
    toDateDefault,
  }) => {

    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
      setAllStore(checkAllStore);

    
    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    setLoading(true);
    let postData = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      type: productType === "ALL" ? "" : productType,
      isExport: false,
      date_type: type,
      filters,
      sortBy,
      start_date: fromDateDefault ?? moment(fromDate).format("YYYY-MM-DD"),
      end_date: toDateDefault ?? moment(toDate).format("YYYY-MM-DD"),
    };

    if (!firstTimePageLoad) {
      const response = await getProductOrder(postData);
      if (response && response.status === 200) {
        setData(response.data.data.rows);
        setPageCount(Math.ceil(response.data.data.count / pageSize));

        // if (accessExport && accessExport.permissions.write_access)
        //   handleExportProductOrders(
        //     sortBy,
        //     filters,
        //     fromDateDefault,
        //     toDateDefault
        //   );
      } else if (response.status === 403) {
        showToastMessage(undefined, response.data.message, "error", false);
        navigate("/profile");
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
    } else {
      setFirstTimePageLoad(false);
    }
    setLoading(false);

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if(checkAllStore){ setAllStore(false) }
  };

  const handleExportProductOrders = async (defaultFilter) => {
    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
      setAllStore(checkAllStore);

    let postData = {
      type: productType === "ALL" ? "" : productType,
      isExport: true,
      filters: defaultFilter.filters,
      date_type: type,
      sortBy: defaultFilter.sortBy,
      start_date: moment(fromDate).format("YYYY-MM-DD"),
      end_date: moment(toDate).format("YYYY-MM-DD"),
    };

    const response = await getProductOrder(postData);

    if (response && response.status === 200) {
      setExportHeader(response.data.data.header);
      setExportData(response.data.data.data);
      setShouldTriggerDownload(true);
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      navigate("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if(checkAllStore){ setAllStore(false) }
  };

  const handleClearSearch = async (event) => {
    event.preventDefault();

    setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
    setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
    setSelectedPeriod("weekly");

    fetchData({
      ...defaultFilter,
      fromDateDefault: moment().startOf("isoWeek").format("YYYY-MM-DD"),
      toDateDefault: moment().endOf("isoWeek").format("YYYY-MM-DD"),
    });
    // handleExportProductOrders(event);
  };

  // const handleSelectedPeriod = async (id) => {
  //   if (id === "weekly") {
  //     setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setSelectedPeriodLabel("By Week");
  //   } else if (id === "monthly") {
  //     setFromDate(moment().startOf("month").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("month").format("ddd MMM DD, YYYY"));
  //     setSelectedPeriodLabel("By Month");
  //   } else if (id === "yearly") {
  //     setFromDate(moment().startOf("year").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("year").format("ddd MMM DD, YYYY"));
  //     setSelectedPeriodLabel("By Year");
  //   }
  // };

  // const handleFromDate = async (data) => {
  //   if (selectedPeriod === "weekly") {
  //     setToDate(moment(data).add(7, "days").utc().format("ddd MMM DD, YYYY"));
  //   } else if (selectedPeriod === "monthly") {
  //     setToDate(moment(data).add(1, "months").utc().format("ddd MMM DD, YYYY"));
  //   } else if (selectedPeriod === "yearly") {
  //     setToDate(moment(data).add(1, "years").utc().format("ddd MMM DD, YYYY"));
  //   }
  // };

  // const handleToDate = async (data) => {
  //   if (selectedPeriod === "weekly") {
  //     setFromDate(
  //       moment(data).subtract(7, "days").utc().format("ddd MMM DD, YYYY")
  //     );
  //   } else if (selectedPeriod === "monthly") {
  //     setFromDate(
  //       moment(data).subtract(1, "months").utc().format("ddd MMM DD, YYYY")
  //     );
  //   } else if (selectedPeriod === "yearly") {
  //     setFromDate(
  //       moment(data).subtract(1, "years").utc().format("ddd MMM DD, YYYY")
  //     );
  //   }
  // };

  const columns = React.useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "title",
        isVisible: true,
        placeholder: "Search by Product Name",
        Cell: ({ value, row, column }) => {
          let defaultIndex = 0;
          row.original.product?.product_images?.forEach((d, i) => {
            if (d.is_default_selected) defaultIndex = i;
          });
          return (
            <div className="row">
              <div className={`col-md-4 ${styles.ProducatImageWapper}`}>
                <img
                  height="70"
                  width="60"
                  src={
                    row.original.product.product_images?.length === 0 ||
                    row.original.product.product_images?.[defaultIndex]?.image ===
                      "" ||
                    row.original.product.product_images?.[defaultIndex]?.image ===
                      "null" ||
                    row.original.product.product_images?.[defaultIndex]?.image ===
                      null
                      ? ""
                      : `${row.original.product.product_images?.[defaultIndex]?.image}`
                  }
                  alt=""
                />
              </div>
              <div className="col-md-8 d-flex align-items-center">
                <h4>{row.original?.product ? row.original.product.title : ""}</h4>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Variation",
        accessor: "variation_title",
        isVisible: true,
        disableSortBy: false,
        Cell: ({ value, row, column }) => {
          return row.original.title;
        },
      },
      {
        Header: "SKU",
        accessor: "sku_id",
        isVisible: true,
        placeholder: "Search by SKU",
        Cell: ({ value, row, column }) => {
          return `${row.original?.product?.sku_id ? row.original.product.sku_id : ""}`;
        },
      },
      {
        Header: "Number Of Units",
        accessor: "no_of_orders",
        isVisible: true,
        disableFilters: true,
      },
      // {
      //   Header: "Number Of Orders",
      //   accessor: "no_of_orders",
      //   isVisible: false,
      //   disableFilters: true,
      //   disableSortBy: true,
      // },
      {
        Header: "Order Total",
        accessor: "order_total",
        isVisible: true,
        disableFilters: false,
        disableSortBy: false,
        Cell: ({ value, row, column }) => {
          return `$${row.original.order_total}`;
        },
      },
      {
        Header: "Action",
        accessor: "id",
        isVisible: true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              <img
                className={`cursor-pointer mr-2 view-icon`}
                src={ViewIcon}
                alt="View Order"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(
                    `/reports/product-orders/${row.original?.product_id}/${row.original?.id}`
                  );
                }}
              />
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <Header title="Products Ordered Report" />
      <div id="MainContent" className="main-content">
        <div className="row d-flex align-items-end">
          {/* <div className="col-12 d-flex align-items-center">
            <span
              className="mb-0 mt-2 pb-0 d-inline-bock mr-3"
              style={{ lineHeight: 1 }}
            >
              Filter By
            </span>
            <RadioBox
              selectedValue={type}
              onChange={() => {
                if (setType) {
                  setType("order_date");
                }
              }}
              label="Order date"
              value="order_date"
            />
            <RadioBox
              selectedValue={type}
              onChange={() => {
                if (setType) {
                  setType("delivery_date");
                }
              }}
              label="Delivery date"
              value="delivery_date"
            />
          </div> */}
          <div className="col-sm-10 p-0">

            <GlobalDateFilters
              isClearSearchBtn
              isSearchIcon
              isDateFilter
              isAllCheckStoreBnt
              isFilterByOption
              isFilterByPeriod
              isSelectedPeriodLabel
              fetchData={() => fetchData({
                ...defaultFilter
              })}
              setType={setType}
              type={type}
              fromDate={fromDate}
              toDate={toDate}
              setToDate={setToDate}
              setFromDate={setFromDate}
              handleClearSearch={handleClearSearch}
              defaultSetCheckAllStore={checkAllStore}
              checkAllStore={(data)=>{setCheckAllStore(data)}}
              selectedPeriod={selectedPeriod}
              setSelectedPeriod={setSelectedPeriod}
              dateFormate={"ddd MMM DD, YYYY"}
              periodOptions={filterOption}
              selectedPeriodLabel={selectedPeriodLabel}
              setSelectedPeriodLabel={setSelectedPeriodLabel}
              key={"product-order-lookup"}
            />
          </div>
          {accessExport && accessExport.permissions.write_access && (
            <div className="col-sm-2 mb-4">
              <div className="mb-2">
                {exportData && exportData.length > 0 && (
                  <CSVLink
                    ref={reference}
                    style={{
                      display: "none",
                      float: "right",
                    }}
                    data={exportData}
                    headers={exportHeader}
                    filename={"ProductsOrderedReport.csv"}
                    className={`link cursor-pointer ml-3 ${styles.searchIconWrapper}`}
                  >
                    DownLoad
                  </CSVLink>
                )}
                {accessExport && accessExport.permissions.write_access && (
                  <span
                    onClick={(e) => handleExportProductOrders(defaultFilter)}
                    className={`link cursor-pointer ${styles.searchIconWrapper}`}
                    style={{ float: "right" }}
                  >
                    <img className={styles.searchIcon} src={ExportIcon} alt="" />
                  </span>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="col-md-3" style={{ paddingLeft: "0px" }}>
          <Select
            label="Type"
            value={productType}
            onChange={(data) => {
              setProductType(data);
            }}
            options={statusList}
            disabled={false}
          />
        </div>

        <br />
        <ReactTable
          columns={columns}
          data={data}
          fetchData={fetchData}
          loading={loading}
          pageCount={pageCount}
          noDataText={"There is no data to display"}
          defaultFilter={defaultFilter}
          displayGlobalSearch={false}
        />
      </div>
    </React.Fragment>
  );
};

export default ProductsOrder;
